import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  wrapper: {
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
